import { useState } from 'react'
import { Dropdown } from 'antd'
import { Icon } from '@iconify/react'

import { normalizeStoryStatus, STORY_STATUS_OPTIONS } from '../utils'
import styles from './StoryMapStatusDropdown.module.css'

const StoryMapStatusDropdown = ({
    value,
    onChange,
    getPopupContainer,
    readOnly = false,
}) => {
    const [open, setOpen] = useState(false)
    const normalized = normalizeStoryStatus(value)
    const selectedOption =
        STORY_STATUS_OPTIONS.find((option) => option.value === normalized) ??
        STORY_STATUS_OPTIONS[0]

    if (readOnly) {
        return (
            <span
                className={`${styles.trigger} ${
                    styles[`trigger_${normalized}`] || ''
                } ${styles.triggerReadOnly}`}
                aria-label="Story status"
            >
                <span className={styles.triggerLabel}>
                    {selectedOption.apiValue}
                </span>
            </span>
        )
    }

    const handleSelect = (nextValue) => {
        const nextStatus = normalizeStoryStatus(nextValue)
        setOpen(false)
        onChange(nextStatus)
    }

    const menu = (
        <div className={styles.menu} role="listbox" aria-label="Story status">
            {STORY_STATUS_OPTIONS.map((option) => {
                const isSelected = option.value === normalized

                return (
                    <button
                        key={option.value}
                        type="button"
                        role="option"
                        aria-selected={isSelected}
                        className={`${styles.menuItem} ${
                            isSelected ? styles.menuItemSelected : ''
                        }`}
                        onClick={() => handleSelect(option.value)}
                    >
                        {option.apiValue}
                    </button>
                )
            })}
        </div>
    )

    return (
        <Dropdown
            dropdownRender={() => menu}
            trigger={['click']}
            placement="bottomLeft"
            open={open}
            onOpenChange={setOpen}
            getPopupContainer={
                getPopupContainer ||
                ((trigger) => trigger.parentNode || document.body)
            }
            overlayClassName={styles.dropdownOverlay}
        >
            <button
                type="button"
                className={`${styles.trigger} ${
                    styles[`trigger_${normalized}`] || ''
                }`}
                aria-haspopup="listbox"
                aria-expanded={open}
                aria-label="Story status"
            >
                <span className={styles.triggerLabel}>
                    {selectedOption.apiValue}
                </span>
                <Icon
                    icon={open ? 'mdi:chevron-up' : 'mdi:chevron-down'}
                    width={14}
                    height={14}
                    className={styles.triggerChevron}
                />
            </button>
        </Dropdown>
    )
}

export default StoryMapStatusDropdown
